<div *ngFor="let field of field.fieldGroup; let i = index" class="flex flex-wrap">
    <formly-field class="col" [field]="field"></formly-field>
    <div
        class="col-sm-2 flex items-center"
        [style.visibility]="to.removeText ? 'visible' : 'collapse'"
    >
        <p-button severity="danger" class="btn btn-danger" style="width: 100%" type="button" (onClick)="remove(i)">
            Remove
        </p-button>
    </div>
</div>
<div style="margin: 30px 0">
    <p-button (onClick)="add()" [hidden]="!to.addText">
        {{ to.addText }}
    </p-button>
</div>
